import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/app'
import { applyThemeMode, readThemeMode } from '@/app/theme-mode'
import '@/styles/theme.css'

// Applied before the first paint so the application never flashes the wrong theme at someone
// working in a dark branch office.
applyThemeMode(readThemeMode())

const container = document.getElementById('root')
if (!container) {
  throw new Error('The #root element is missing from index.html.')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
